export default __webpack_public_path__ + "static/media/grid.774d3b9f.svg";